import React, { useEffect, createElement } from 'react';
import { TopBar } from './src/components/TopBar';
import { HeroSection } from './src/components/HeroSection';
import { MultiStepForm } from './src/components/MultiStepForm';
import { LegalFooter } from './src/components/LegalFooter';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    document.title = 'The Founders Law';
    // Meta Pixel initialization
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    window.fbq('init', '290783800709534');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-navy flex flex-col relative" data-id="element-0">
      <TopBar data-id="element-1" />
      <main className="flex-1" data-id="element-2">
        <HeroSection data-id="element-3" />
        <MultiStepForm data-id="element-4" />
      </main>
      <LegalFooter data-id="element-5" />
      <noscript data-id="element-6">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=290783800709534&ev=PageView&noscript=1" alt="" data-id="element-7" />
      </noscript>
    </div>;
}